import React from 'react'
import PropTypes from 'prop-types'
import {findDOMNode} from "react-dom"

import ListItems from "../item/rows"
import GroupHeader from "./group-header"
import GroupHeaderWithColumns from "./list-header"
import ErrorBoundary from "../../../../error-boundary"

const debug = false
// const debug = "GenericListGroup"

export default class GenericListGroup extends React.Component {

    static propTypes = {
        module          : PropTypes.object,
        groupByValue    : PropTypes.any,

        groupByEnabled  : PropTypes.bool,
        showEmpty       : PropTypes.bool,
        isFirst         : PropTypes.bool,
    }

    static defaultProps = {
        showEmpty       : false,
    }

    componentDidMount() {
        gd.bus.subscribe('g-list:group-hover', this, this.onGroupHovered)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    onGroupHovered = () => {gd.utils.Dom.toggleClass(findDOMNode(this),'force-show-header', this.props.module.isGroupHovered(this.props.groupByValue))}
    onMouseOverGroup = (e) => {this.props.module.setGroupHover(this.props.groupByValue)}

    onToggleGroup = (e) => {
        e && e.stopPropagation()
        this.props.module.groupBy.toggleGroup(this.props.groupByValue)
        this.forceUpdate()
    }

    renderHeader(group, isCollapsed) {
        debug && console.log(debug, 'renderHeader', group, isCollapsed, this.props.module.groupBy)
        if (!this.props.module.groupBy.isEnabled || !group) return false

        let HeaderComponent
        switch (this.props.module.headerMode) {
            case 'hidden'   : /* no header*/ break
            case 'multiple' : HeaderComponent = GroupHeaderWithColumns; break

            case 'sticky'   :
            case 'default'  :
            default         : HeaderComponent = GroupHeader; break
        }

        if (!HeaderComponent) return false

        return <HeaderComponent module      = {this.props.module}
                                group       = {group}
                                isCollapsed = {isCollapsed}
                                onClick     = {this.onToggleGroup}/>
    }

    render() {
        const isCollapsed   = this.props.groupByValue ? this.props.module.groupBy.isCollapsed(this.props.groupByValue) : false
        const group         = this.props.groupByValue ? this.props.module.data.getGroup(this.props.groupByValue) : null

        const classes = Classes('ui5-glist-group', this.props.className, {
            'is-first'          : this.props.isFirst,
            'open'              : !isCollapsed,
            'closed'            : isCollapsed,
            'force-show-header' : this.props.module.isGroupHovered(this.props.groupByValue)
        })

        return (
            <div className      = {classes}
                 style          = {{width: this.props.module.columns.combinedWidth}}
                 onMouseEnter   = {!isCollapsed ? this.onMouseOverGroup : null}>
                <ErrorBoundary>
                {this.renderHeader(group, isCollapsed)}
                </ErrorBoundary>

                {!isCollapsed &&
                    <ListItems module       = {this.props.module}
                               items        = {group ? group.models : null}
                               showEmpty    = {this.props.showEmpty}/>}
            </div>
        )
    }
}
